import { TSection } from "../../../../components/MiniCards/MiniCards"
import { TDiversCartMiniTable } from "../types/DiversificacionCarteraTypes"
import { parseIsoDate } from "@/utils/DateFormatter"

type TFormatMiniTableDataProps = {
    dataMiniCard: TDiversCartMiniTable
}

const formatMiniCardDate = (fecha: TDiversCartMiniTable["fecha"]): string | null =>
{
    const parsedDate = parseIsoDate(fecha);
    if(!parsedDate)
    {
        return null;
    }

    return parsedDate.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const FormatMiniTableData = ({ dataMiniCard } : TFormatMiniTableDataProps) => {
    
    const dataSection: TSection[] = [
        {
            title: "Volatilidad",
            data: `${dataMiniCard.volatilidad.toString()}%`
        },
        {
            title: "Mejoría Diversificación",
            data: `${dataMiniCard.mejoriaDiversificacion.toString()}%`
        },
        {
            title: "Reducción Riesgo",
            data: `${dataMiniCard.reduccionDeRiesgo.toString()}%`
        },
        {
            title: "Índice diversificación",
            data: `${dataMiniCard.indiceDiversificacion.toString()}`
        },
        {
            title: "Número de Instrumentos",
            data: `${dataMiniCard.numeroInstrumentos.toString()}`
        }
    ]

    const formattedDate = formatMiniCardDate(dataMiniCard.fecha);
    if(formattedDate)
    {
        dataSection.push({
            title: "Fecha",
            data: formattedDate
        });
    }

    return dataSection;
}